module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "CardanoLogo.c8e54c54.svg";